import {
  LIST, LIST_DONE, CREATE, CREATE_DONE, UPDATE, UPDATE_DONE, DELETE, DELETE_DONE,
} from './types';

export const list = () => ({
  type: LIST,
});

export const listDone = (err, apps) => ({
  type: LIST_DONE,
  payload: err || apps,
  error: !!err,
});

export const create = (app, cb) => ({
  type: CREATE,
  payload: app,
  cb,
});

export const createDone = (err, app) => ({
  type: CREATE_DONE,
  payload: err || app,
  error: !!err,
});

export const update = (app, cb) => ({
  type: UPDATE,
  payload: app,
  cb,
});

export const updateDone = (err, app) => ({
  type: UPDATE_DONE,
  payload: err || app,
  error: !!err,
});

export const del = app => ({
  type: DELETE,
  payload: app,
});

export const delDone = (err, app) => ({
  type: DELETE_DONE,
  payload: err || app,
  error: !!err,
});
